import { FilterState } from 'views/components/Filters'
import { TransactionStatus } from '../../../graphql'

export const availableFilters = [
	{
		key: 'includeSubmittedTransactions',
		label: 'Needs Approval',
		initialValue: true,
	},
	{
		key: 'includeProcessingTransactions',
		label: 'Processing',
		initialValue: true,
	},
	{
		key: 'includeCompletedTransactions',
		label: 'Completed',
		initialValue: false,
	},
	{
		key: 'includeCancelledTransactions',
		label: 'Cancelled',
		initialValue: false,
	},
]

export function buildFilterVariables( filterState: FilterState ) {
	const statuses: TransactionStatus[] = []

	filterState.forEach( ( filterOption ) => {
		if ( filterOption.checked === 'on' ) {
			switch ( filterOption.key ) {
				case 'includeSubmittedTransactions':
					statuses.push( TransactionStatus.Submitted )
					break
				case 'includeProcessingTransactions':
					statuses.push( TransactionStatus.Processing )
					break
				case 'includeCompletedTransactions':
					statuses.push( TransactionStatus.Completed )
					break
				case 'includeCancelledTransactions':
					statuses.push( TransactionStatus.Cancelled )
					break
				default:
					break
			}
		}
	} )

	return { transactionStatuses: statuses }
}
